import { AxiosPromise } from "axios";
import {
  PermissionPresetDto,
  PermissionPresetsResourceApi,
} from "../generated/dashboard-client";
import { dashboardApiConfig, ops } from "./config";

const api = new PermissionPresetsResourceApi(dashboardApiConfig);

const PermissionPresetsApi = {
  getPresets(teamId: string): AxiosPromise<PermissionPresetDto[]> {
    return api.getPresets(teamId, ops());
  },
  createPreset(teamId: string, dto: PermissionPresetDto): AxiosPromise<PermissionPresetDto> {
    return api.createPreset(teamId, dto, ops());
  },
  updatePreset(teamId: string, id: string, dto: PermissionPresetDto): AxiosPromise<PermissionPresetDto> {
    return api.updatePreset(teamId, id, dto, ops());
  },
  deletePreset(teamId: string, id: string): AxiosPromise<void> {
    return api.deletePreset(teamId, id, ops());
  },
};

export default PermissionPresetsApi;
